import { QueryClient } from '@tanstack/react-query';

// Create React Query client (singleton)
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes - avoid re-fetching on navigation
      gcTime: 10 * 60 * 1000, // 10 minutes - keep unused data in cache
    },
    mutations: {
      retry: 1,
    },
  },
});
